import Vue from 'vue'
import VueRouter from 'vue-router'
import LandingComponent from '../components/landing-component'
// import GuideComponent from '../components/guide/guide-component'
import NotFoundComponent from '../components/not-found-component'
import HeaderLandingComponent from '../components/header/header-landing-component'
import HeaderComponent from '../components/header/header-component'
import SurveyComponent from '../components/survey/survey-component'

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'landing',
        components: {
            default: LandingComponent,
            header: HeaderLandingComponent
        }
    },
    // {
    //     path: '/guide',
    //     name: 'guide',
    //     components: {
    //         default: GuideComponent,
    //         header: HeaderComponent
    //     }
    // },
    {
        path: '/survey',
        name: 'survey',
        components: {
            default: SurveyComponent,
            header: HeaderComponent
        }
    },
    {
        path: '*',
        name: 'not-found',
        components: {
            default: NotFoundComponent,
            header: HeaderComponent
        }
    },
];


const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

export default router
